<template>
  <va-form :id="id" :item="item" redirect="show">
    <v-row justify="center">
      <v-col sm="6">
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2">
              {{ title }}
            </div>
          </template>
          <v-card-text>
            <va-text-input source="title"></va-text-input>
             <custom-horizontal-file-input source="sponsor" accept="image/png, image/jpeg" preview></custom-horizontal-file-input>
          </v-card-text>
          <va-save-button></va-save-button>
        </base-material-card>
      </v-col>
    </v-row>
  </va-form>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
